import { Lock, ShieldCheck, ShieldEllipsis } from "lucide-react"

import { cn } from "../../lib/utils"

type TrustBadgesProps = {
  className?: string
  labels?: {
    verified?: string
    ssl?: string
    encryption?: string
  }
}

export function TrustBadges({ className, labels }: TrustBadgesProps) {
  const verified = labels?.verified ?? "Security Verified"
  const ssl = labels?.ssl ?? "SSL Protected"
  const encryption = labels?.encryption ?? "End-to-End Encryption"

  return (
    <div className={cn("flex flex-wrap items-center gap-3 text-xs text-muted-foreground", className)}>
      <span className="inline-flex items-center gap-1.5 rounded-full border border-white/10 px-3 py-1">
        <ShieldCheck className="size-3.5 text-emerald-400" />
        {verified}
      </span>
      <span className="inline-flex items-center gap-1.5 rounded-full border border-white/10 px-3 py-1">
        <Lock className="size-3.5 text-sky-400" />
        {ssl}
      </span>
      <span className="inline-flex items-center gap-1.5 rounded-full border border-white/10 px-3 py-1">
        <ShieldEllipsis className="size-3.5 text-violet-400" />
        {encryption}
      </span>
    </div>
  )
}
